import {useState, useEffect, useContext} from 'react'
import {UpdateUserContext} from "../../App"
import {MathJax, MathJaxContext } from "better-react-mathjax";
import {Aff_question} from "./Aff_question"
import {Chargement} from "./Chargement"
import {Mode_classe} from "./Mode_classe"
import {Modal} from "../question/Modal"
import {niveaux} from "../config/Config"
import {useFetch} from "../hooks/useFetch";

export function Mesquestions0 ({auth}) {

  const updateUsercontext = useContext(UpdateUserContext)

  const [niveau, setNiveau] = useState('')
  const [classe, setClasse] = useState({
    active: false,
    nom: '',
  })
  const [meslistes, setMeslistes] = useState({})
  const [titreAff, setTitreAff] = useState([])
  const [listeactive, setlisteactive] = useState('')
  const [chargement, setChargement] = useState(false)
  const [mode_classe, setMode_classe] = useState({
    active:false,
    title_mes_listes:[]
  })


  const [msg, setMsg] = useState({
    listeMesquestions:'',
    supprMesquestions:'',
  })
  const cleanMsg = (name) => {
    setTimeout(e => {
          setMsg({...msg, [name]:''})
        }, 3000)
  }

  // ============= New ================

  const {data, fetchApi, errors} = useFetch([])
  const Mes_niveaux = []

  useEffect(()=>{
    fetchApi('api-questions', {...auth, action:'RecupMesNiveaux', niveau:'6e'})
  },[]);

    niveaux.forEach((niv, k) => {
      if(data.includes(niv.slug)) {Mes_niveaux.push({title:niv.title, slug:niv.slug})}
    })
  //console.log('errors : ', errors)
  //console.log('data : ', data)
  //console.log('Mes_niveaux : ', Mes_niveaux)
    
  // ==================================


  //console.log(meslistes[mode_classe.title_mes_listes])

  /*const handleChange = (e) => {
    const name = e.target.name
    let tab = Object.keys(meslistes).filter(elt => elt.toLowerCase().includes(e.target.value.toLowerCase()))
    setTitreAff(tab)
  }*/

  const handleClick = (e) => {
    if(e.target.attributes.name?.nodeValue == 'mesquestions'){
      setlisteactive(e.target.querySelector('.suppr_serie').id)
    } 
    else if(e.target.parentNode.attributes.name?.nodeValue == 'mesquestions'){
      setlisteactive(e.target.parentNode.querySelector('.suppr_serie').id)
    } 
    else if(e.target.className == 'mode_classe'){
      setMode_classe({...mode_classe, active:true, title_mes_listes:e.target.id})
      //window.location.href = '#choisir'
    }
  }

  const updateListe = (auth) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'Mesquestions', niveau})
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data)
      //return
      setMeslistes(data)
      setTitreAff(Object.keys(data))
      setChargement(false)
    })
    .catch(err => console.log(err))
  }

  const sendData = (auth, name) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, niveau, classe:classe.nom})
    })
    .then(response => response.json())
    .then(data => {
      setMsg({...msg, [auth.action]:data})
      cleanMsg(auth.action)
      updateListe(auth)
      setlisteactive('')
      updateUsercontext()

      //window.location.href = '#choisir'
      if(name != 'supprMesquestions'){
        setTimeout(e => {
          //window.location.href = '#liste_devoirs'
        }, 5000)
      }
    })
    .catch(err => console.log(err))
  }

  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    if(name == 'supprMesquestions'){
      let confirm = window.confirm("Voulez-vous vraiment supprimer cette série de vos questions ?");
      if (!confirm) {return}
      auth = {...auth, action:name, id:e.target.id}
    } else {
      const param = Object.keys(meslistes).filter(elt => elt.split('__')[0] == e.target.id)[0]
      auth = {...auth, action:'listeMesquestions', etoile:'0', id:e.target.id, nb_question:meslistes[param].length}
    }
    sendData(auth, name)
  }

	useEffect(()=>{
		if (niveau) {
      updateListe({...auth, niveau})
    }
	},[niveau]); // Fetch ==> Mesquestions

  useEffect(()=>{
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[meslistes, mode_classe]); // MathsJax 

  //console.log('meslistes ', meslistes)
  //console.log({...auth, titre:mode_classe.title_mes_listes.split('__')[1].split(' (')[0], questions:meslistes[mode_classe.title_mes_listes]})
  //<Modal auth={{...auth, titre:mode_classe.title_mes_listes.split('__')[1].split(' (')[0], questions:meslistes[mode_classe.title_mes_listes]}} setShow_activite={setMode_classe} />
  return (
    mode_classe.active ? 
      <div className='modal active'>
          <div className="suppr_serie" onClick={e=>{
            setMode_classe(false)
            e.target.parentNode.classList.remove('active')
          }}></div>
        <Mode_classe auth={{...auth, titre:mode_classe.title_mes_listes.split('__')[1].split(' (')[0], questions:meslistes[mode_classe.title_mes_listes]}} setMode_classe={setMode_classe} />
      </div> :
    <div className='content max' style={{textAlign:'left'}}>
    	<h1>Mes séries de questions</h1>
      <br/>
      Choisir un niveau : <br/>
      {Mes_niveaux.map((niv,k) => 
        <span key={k}>
        <span className={'btn_param' + (niveau == niv.slug ? ' active' :'')} onClick={()=>{
            setNiveau(niv.slug)
            setChargement(true)
          }}>{niv.title}
        </span>
        {k == 5 && <br/>}
      </span>)}
      <br/>
      <br/>
        <br/>
        <MathJaxContext>
        </MathJaxContext>
        {msg.supprMesquestions ? <span dangerouslySetInnerHTML={{ __html:msg.supprMesquestions}}></span> : ''}
        {chargement ? <Chargement /> : 
          <div id='choisir'>
            {titreAff.map((e, k) => 
              <div key={k} name="mesquestions" className={'mesquestions' + (e.split('__')[0] == listeactive ? ' active' :'') } onClick={handleClick} >
                <h3>{e.split('__')[1]}</h3> <br/>
                 <span dangerouslySetInnerHTML={{ __html:msg.supprMesquestions}}></span> 
                <div>
                  <div name="mode_classe" className="mode_classe" id={e} onClick={handleClick}></div>
                  <div name="supprMesquestions" id={e.split('__')[0]} className="suppr_serie" onClick={handleSubmit} ></div>
                </div>
                {meslistes[e].map((q, k0)=> 
                   <Aff_question key={k0} key_tab={'0'} question={q} tag={""} />
                  )}
                <br/>
                <br/>
                <div align="center">
                  <button className="btn standard" onClick={()=>setClasse({...classe, active:true})} >Envoyer à une classe</button>
                  <br/><br/>
                  {classe.active ? 
                  <>
                    {auth.classes.map((cl, k) => 
                        <span key={k} className={'btn_param'+(cl == classe.nom ? ' active' : '') } name="classe" onClick={(e)=>setClasse({...classe, nom:cl})} >{cl}</span>)}
                    <br/><br/>
                    {classe.nom ? <button name="listeMesquestions" id={e.split('__')[0]} className="btn standard" onClick={handleSubmit} >{'Envoyer cette série aux '+classe.nom}</button> :''}
                  </>
                  :''}
                </div>
              </div>)}
                {msg.listeMesquestions ? <span dangerouslySetInnerHTML={{ __html:msg.listeMesquestions}}></span> : ''}
           </div>
          }
        {titreAff.length || !niveau || chargement ? '' : <div className='info'><br/>Vous n'avez pas encore de série de questions <br/>pour le niveau {niveau}.<br/><br/></div>}
    </div>
  )
}